import { useRecoilValue } from 'recoil';

import atoms from '@Components/Utilities/SandhillsAtoms';
import TranslationText from '@Components/Utilities/TranslationText';

const BulletListAndImage = (props) => {
    const routes = useRecoilValue(atoms.routes);

    return (
        <div class="bulletListAndImageSection">
            <div class="container">
                <h2><TranslationText tKey='sandhills.tradesites.mvc.PrivateFlightsMadeSimple' /></h2>
                <ul class="bullet-list">
                    {props.bulletList && props.bulletList.map((bulletText, index) => (
                        <li key={index}><span>{bulletText}</span></li>
                    ))}
                </ul>
            </div>
            <div class="hero-img">
                <img src={routes.CDNBaseUrl + 'Images/SiteArt/CharterHub/bg-hero-2.png'} />
            </div>
        </div>
    );
};

export default BulletListAndImage;